export const gameWait = 5000
export const questionBuffer = 1000
